/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, change } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { REQUEST_FORM_NAME } from '../../constants';
import { RequestFormView } from './request-form-view-car';
import {
	getAddressesOptionsSelector,
	getTypesSelector,
	getContactsOptionsSelector,
	getModesSelector,
	getPartnersOptionsSelector,
	getIsPrrSelector,
	getRequestFormInitialValuesSelector,
	getAddressSearchValueSelector,
	getContactSearchValueSelector,
	getContactsSelector,
	getPartnerSearchValueSelector,
	getFeaturesSelector,
	getIsValidationCheckboxDisabledSelector,
	getIsAvailablePartnersSelector,
	getIsAvailableAddressesSelector,
	getIsAvailableContactsSelector,
	getTenderTypesSelector,
	getTenderCompaniesSelector,
	getIsMyCarrierSelectedSelector,
	getInfoSelector,
	getSeatTypesSelector,
	getIsTenderSelectedSelector,
	getIsOptionsListLoadingSelector,
	getIsRequestInfoLoadingSelector,
	getIsFormValueSelector,
	getIsMyTransportSelectedSelector,
	getCustomersSelector,
	getIsCustomersLoadingSelector,
} from '../../selectors';
import {
	getContactsAction,
	getAddressesAction,
	setActivePointIndexAction,
	setRequestInfoAction,
	setAddressSearchValueAction,
	setContactSearchValueAction,
	setContactsAction,
	setPartnerSearchValueAction,
	deletePointInfoAction,
	getPartnersAction,
} from '../../actions';
import { deletePointInfo, validateRequestForm } from '../../utils';

const RequestFormWrapper = ({
	onSetIsPartnerModalShow,
	onSetIsAddressModalShow,
	onSetIsContactModalShow,
	customers,
	isCustomersLoading,
	onGetAddresses,
	partners,
	addresses,
	onGetContacts,
	contacts,
	types,
	modes,
	isPrr,
	info,
	onSetActivePointIndex,
	RequestInfo,
	onSetRequestInfo,
	onSetAddressSearchValue,
	addressSearchValue,
	contactSearchValue,
	onSetContactSearchValue,
	onSetContacts,
	contactsOptions,
	partnerSearchValue,
	onSetPartnerSearchValue,
	onDeletePointInfo,
	features,
	onGetPartners,
	isValidationCheckboxDisabled,
	onFieldChange,
	isAvailablePartners,
	isAvailableAddresses,
	isAvailableContacts,
	tenderTypes,
	tenderCompanies,
	isMyCarrierSelected,
	isMyTransportSelected,
	isTenderSelected,
	seatTypes,
	isOptionsListLoading,
	isRequestInfoLoading,
	formValues,
}) => {
	const handlePartnerChange = (value, index) => {
		const currentPartner = partners[index].find(partner => partner.id === value);

		if (currentPartner) {
			const newPoints = [...(RequestInfo.points || [])];

			newPoints[index] = {
				...(RequestInfo.points?.[index] || {}),
				partner: {
					id: currentPartner.id,
					inn: currentPartner.inn,
					name: currentPartner.name,
					ogrn: currentPartner.ogrn,
				},
			};

			delete newPoints[index].address;
			delete newPoints[index].contact;

			// change form to remove address and contact fields from form
			onFieldChange(REQUEST_FORM_NAME, 'points', newPoints);

			if (partnerSearchValue[index]) {
				onSetPartnerSearchValue({ ...partnerSearchValue, [index]: '' });
			}

			if (contactSearchValue[index]) {
				onSetContactSearchValue({ ...contactSearchValue, [index]: '' });
			}

			if (addressSearchValue[index]) {
				onSetAddressSearchValue({ ...addressSearchValue, [index]: '' });
			}

			onSetRequestInfo({ ...RequestInfo, points: newPoints });
		}

		onGetAddresses({ id: value, index });
		onSetContacts({ ...contactsOptions, [index]: [] });
	};

	const handleAddressChange = (value, index) => {
		const currentAddress = addresses[index].find(address => address.id === value);

		if (currentAddress) {
			const newPoints = [...(RequestInfo.points || [])];

			newPoints[index] = {
				...(RequestInfo.points?.[index] || {}),
				address: {
					id: currentAddress.id,
					partner_id: currentAddress.partner_id,
					name: currentAddress.name,
					address: currentAddress.address,
					work_mode: currentAddress.work_mode,
					kladr_id: currentAddress.kladr_id,
					fias_id: currentAddress.fias_id,
					region: currentAddress.region,
					region_with_type: currentAddress.region_with_type,
					city: currentAddress.city,
					city_with_type: currentAddress.city_with_type,
					settlement: currentAddress.settlement,
					settlement_with_type: currentAddress.settlement_with_type,
				},
			};

			delete newPoints[index].contact;

			onFieldChange(REQUEST_FORM_NAME, 'points', newPoints);

			if (contactSearchValue[index]) {
				onSetContactSearchValue({ ...contactSearchValue, [index]: '' });
			}

			if (addressSearchValue[index]) {
				onSetAddressSearchValue({ ...addressSearchValue, [index]: '' });
			}

			onSetRequestInfo({ ...RequestInfo, points: newPoints });
		}

		onGetContacts({ id: value, index });
	};

	const handleContactChange = (value, index) => {
		const currentContact = contacts[index].find(contact => contact.id === value);

		if (currentContact) {
			const newPoints = [...(RequestInfo.points || [])];

			newPoints[index] = {
				...(RequestInfo.points?.[index] || {}),
				contact: {
					id: currentContact.id,
					email: currentContact.email,
					extension: currentContact.extension,
					first_name: currentContact.first_name,
					is_default: currentContact.is_default,
					last_name: currentContact.last_name,
					middle_name: currentContact.middle_name,
					phone: currentContact.phone,
				},
			};

			if (contactSearchValue[index]) {
				onSetContactSearchValue({ ...contactSearchValue, [index]: '' });
			}

			onSetRequestInfo({ ...RequestInfo, points: newPoints });
		}
	};

	const handlePointChange = (value, index, field) => {
		const newPoints = [...(RequestInfo.points || [])];

		newPoints[index] = {
			...(RequestInfo.points?.[index] || {}),
			[field]: value,
		};

		onSetRequestInfo({ ...RequestInfo, points: newPoints });
	};

	const handleAddPartnerButtonClick = index => {
		onSetIsPartnerModalShow(true);
		onSetActivePointIndex(index);
		onSetRequestInfo(RequestInfo);
	};

	const handleAddAddressButtonClick = index => {
		if (!RequestInfo.points?.[index]?.partner) {
			return;
		}
		if (!RequestInfo.points?.[index]?.partner?.id) {
			return;
		}

		onSetIsAddressModalShow(true);
		onSetActivePointIndex(index);
		onSetRequestInfo(RequestInfo);
	};

	const handleAddContactButtonClick = index => {
		if (!RequestInfo.points?.[index]?.address) {
			return;
		}

		if (!RequestInfo.points?.[index]?.address?.id) {
			return;
		}

		onSetIsContactModalShow(true);
		onSetActivePointIndex(index);
		onSetRequestInfo(RequestInfo);
	};

	const handlePointAdd = fields => {
		onGetPartners(fields.length);
		fields.push({});
	};

	const handlePointDelete = index => {
		onDeletePointInfo({
			partners: deletePointInfo(partners, index),
			addresses: deletePointInfo(addresses, index),
			contacts: deletePointInfo(contacts, index),
			partnerSearchValue: deletePointInfo(partnerSearchValue, index),
			addressSearchValue: deletePointInfo(addressSearchValue, index),
			contactSearchValue: deletePointInfo(contactSearchValue, index),
			requestInfo: { ...RequestInfo, points: RequestInfo.points.filter((_, i) => i !== index) },
		});
	};

	const handlePartnerSearchChange = ({ searchQuery }, index) => {
		onSetPartnerSearchValue({ ...partnerSearchValue, [index]: searchQuery });
	};

	const handleAddressSearchChange = ({ searchQuery }, index) => {
		const id = RequestInfo?.points?.[index]?.partner?.id;

		if (!id) return;

		onSetAddressSearchValue({ ...addressSearchValue, [index]: searchQuery });
	};

	const handleContactSearchChange = ({ searchQuery }, index) => {
		const id = RequestInfo?.points?.[index]?.address?.id;

		if (!id) return;

		onSetContactSearchValue({ ...contactSearchValue, [index]: searchQuery });
	};

	const handleTypeChange = value => {
		if (value === 1) {
			onFieldChange(REQUEST_FORM_NAME, 'is_thermo_check', true);
			onFieldChange(REQUEST_FORM_NAME, 'is_validated', false);
		}

		if (value === 2) {
			onFieldChange(REQUEST_FORM_NAME, 'is_thermo_check', false);
			onFieldChange(REQUEST_FORM_NAME, 'is_validated', false);
		}

		if (value === 3) {
			onFieldChange(REQUEST_FORM_NAME, 'is_thermo_check', true);
			onFieldChange(REQUEST_FORM_NAME, 'is_validated', true);
		}
	};

	return (
		<RequestFormView
			customers={customers}
			isCustomersLoading={isCustomersLoading}
			partners={partners}
			addresses={addresses}
			contacts={contacts}
			onPartnerChange={handlePartnerChange}
			onAddressChange={handleAddressChange}
			onContactChange={handleContactChange}
			onAddPartnerButtonClick={handleAddPartnerButtonClick}
			onAddAddressButtonClick={handleAddAddressButtonClick}
			onAddContactButtonClick={handleAddContactButtonClick}
			onPartnerSearchChange={handlePartnerSearchChange}
			onAddressSearchChange={handleAddressSearchChange}
			onContactSearchChange={handleContactSearchChange}
			partnerSearchValue={partnerSearchValue}
			addressSearchValue={addressSearchValue}
			contactSearchValue={contactSearchValue}
			onPointChange={handlePointChange}
			onPointAdd={handlePointAdd}
			onPointDelete={handlePointDelete}
			types={types}
			modes={modes}
			features={features}
			tenderTypes={tenderTypes}
			tenderCompanies={tenderCompanies}
			isPrr={isPrr}
			info={info}
			isValidationCheckboxDisabled={isValidationCheckboxDisabled}
			onTypeChange={handleTypeChange}
			isAvailablePartners={isAvailablePartners}
			isAvailableAddresses={isAvailableAddresses}
			isAvailableContacts={isAvailableContacts}
			isMyCarrierSelected={isMyCarrierSelected}
			isMyTransportSelected={isMyTransportSelected}
			isTenderSelected={isTenderSelected}
			seatTypes={seatTypes}
			isOptionsListLoading={isOptionsListLoading}
			isRequestInfoLoading={isRequestInfoLoading}
			formValues={formValues}
		/>
	);
};

const withForm = reduxForm({
	form: REQUEST_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validateRequestForm,
	keepDirtyOnReinitialize: true,
})(RequestFormWrapper);

const mapStateToProps = createStructuredSelector({
	isRequestInfoLoading: getIsRequestInfoLoadingSelector(),
	isOptionsListLoading: getIsOptionsListLoadingSelector(),
	initialValues: getRequestFormInitialValuesSelector(),
	RequestInfo: getRequestFormInitialValuesSelector(),
	customers: getCustomersSelector(),
	isCustomersLoading: getIsCustomersLoadingSelector(),
	partners: getPartnersOptionsSelector(),
	formValues: getIsFormValueSelector(),
	addresses: getAddressesOptionsSelector(),
	contacts: getContactsOptionsSelector(),
	modes: getModesSelector(),
	types: getTypesSelector(),
	features: getFeaturesSelector(),
	tenderTypes: getTenderTypesSelector(),
	tenderCompanies: getTenderCompaniesSelector(),
	isPrr: getIsPrrSelector(),
	info: getInfoSelector(),
	partnerSearchValue: getPartnerSearchValueSelector(),
	addressSearchValue: getAddressSearchValueSelector(),
	contactSearchValue: getContactSearchValueSelector(),
	contactsOptions: getContactsSelector(),
	isValidationCheckboxDisabled: getIsValidationCheckboxDisabledSelector(),
	isAvailablePartners: getIsAvailablePartnersSelector(),
	isAvailableAddresses: getIsAvailableAddressesSelector(),
	isAvailableContacts: getIsAvailableContactsSelector(),
	isMyCarrierSelected: getIsMyCarrierSelectedSelector(),
	isMyTransportSelected: getIsMyTransportSelectedSelector(),
	isTenderSelected: getIsTenderSelectedSelector(),
	seatTypes: getSeatTypesSelector(),
});

const mapDispatchToProps = {
	onGetAddresses: getAddressesAction,
	onGetContacts: getContactsAction,
	onSetPartnerSearchValue: setPartnerSearchValueAction,
	onSetActivePointIndex: setActivePointIndexAction,
	onSetRequestInfo: setRequestInfoAction,
	onSetAddressSearchValue: setAddressSearchValueAction,
	onSetContactSearchValue: setContactSearchValueAction,
	onSetContacts: setContactsAction,
	onDeletePointInfo: deletePointInfoAction,
	onGetPartners: getPartnersAction,
	onFieldChange: change,
};

const RequestFormCar = connect(mapStateToProps, mapDispatchToProps)(withForm);

RequestFormWrapper.propTypes = {
	onSetIsPartnerModalShow: PropTypes.func.isRequired,
	onSetIsAddressModalShow: PropTypes.func.isRequired,
	onSetIsContactModalShow: PropTypes.func.isRequired,
	isRequestInfoLoading: PropTypes.bool.isRequired,
	isValidationCheckboxDisabled: PropTypes.bool.isRequired,
	onFieldChange: PropTypes.func.isRequired,
	customers: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isCustomersLoading: PropTypes.bool.isRequired,
	onGetAddresses: PropTypes.func.isRequired,
	partners: PropTypes.object.isRequired,
	addresses: PropTypes.object.isRequired,
	formValues: PropTypes.object,
	contacts: PropTypes.object.isRequired,
	modes: PropTypes.array.isRequired,
	types: PropTypes.array.isRequired,
	features: PropTypes.array.isRequired,
	tenderTypes: PropTypes.array.isRequired,
	tenderCompanies: PropTypes.array.isRequired,
	onGetContacts: PropTypes.func.isRequired,
	isPrr: PropTypes.shape({ isPrr: PropTypes.bool, points: PropTypes.arrayOf(PropTypes.bool) }).isRequired,
	info: PropTypes.object.isRequired,
	onSetPartnerSearchValue: PropTypes.func.isRequired,
	onSetActivePointIndex: PropTypes.func.isRequired,
	RequestInfo: PropTypes.object.isRequired,
	onSetRequestInfo: PropTypes.func.isRequired,
	onSetAddressSearchValue: PropTypes.func.isRequired,
	onSetContactSearchValue: PropTypes.func.isRequired,
	onSetContacts: PropTypes.func.isRequired,
	contactsOptions: PropTypes.object.isRequired,
	onDeletePointInfo: PropTypes.func.isRequired,
	onGetPartners: PropTypes.func.isRequired,
	partnerSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	addressSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	contactSearchValue: PropTypes.shape({ 0: PropTypes.string, 1: PropTypes.string }).isRequired,
	isAvailablePartners: PropTypes.bool.isRequired,
	isAvailableAddresses: PropTypes.bool.isRequired,
	isAvailableContacts: PropTypes.bool.isRequired,
	isMyCarrierSelected: PropTypes.bool.isRequired,
	isMyTransportSelected: PropTypes.bool.isRequired,
	isTenderSelected: PropTypes.bool.isRequired,
	seatTypes: PropTypes.array.isRequired,
	isOptionsListLoading: PropTypes.shape({
		tenderTypes: PropTypes.bool.isRequired,
		tenderCompanies: PropTypes.bool.isRequired,
		partners: PropTypes.bool.isRequired,
		addresses: PropTypes.shape({
			0: PropTypes.bool.isRequired,
			1: PropTypes.bool.isRequired,
		}).isRequired,
		contacts: PropTypes.bool.isRequired,
		rates: PropTypes.bool.isRequired,
		types: PropTypes.bool.isRequired,
		modes: PropTypes.bool.isRequired,
		seatTypes: PropTypes.bool.isRequired,
	}).isRequired,
};

export { RequestFormCar };
